/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import {Vue} from 'vue-property-decorator';
import Router, {Route} from 'vue-router';
import Home from '@/views/Home/index.vue';
import Authenticate from '@/views/Authenticate/index.vue';
import Login from '@/views/Login/index.vue';
import UserGuide from '@/views/UserGuide/index.vue';
import ItemAdd from '@/views/ItemAdd/index.vue';
import Item from '@/views/Item/index.vue';
import BuildAdd from '@/views/BuildAdd/index.vue';
import Terms from '@/views/Terms/index.vue';
import {authenticated} from '@/router/authentication-guard';
import {steamAuthenticateReady} from '@/router/steam-guard';
import {itemValidated} from '@/router/item-guard';
import {configurationGuard} from '@/router/configuration-guard';
import {notFoundGuard} from '@/router/not-found-guard';
import {languageGuard} from '@/router/language-guard';
import {focusHook} from '@/router/focus-hook';

Vue.use(Router);

/**
 * Router object exposed for view navigation.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
const router: Router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    // tslint:disable-next-line
    scrollBehavior: () => {
        return { x: 0, y: 0 };
    },
    routes: [
        {
            path: '/',
            beforeEnter: authenticated,
            redirect: '/item',
            component: {
                // tslint:disable-next-line
                render(c) { return c('router-view'); },
            },
            children: [
                {
                    path: '/item',
                    name: 'item',
                    component: Home,
                },
                {
                    path: '/item/add',
                    name: 'item-add',
                    component: ItemAdd,
                },
                {
                    path: '/item/:itemId',
                    name: 'item-show',
                    props: true,
                    component: Item,
                    beforeEnter: itemValidated,
                },
                {
                    path: '/item/:itemId/build/add',
                    props: true,
                    name: 'build-add',
                    component: BuildAdd,
                    beforeEnter: itemValidated,
                },
            ],
        },
        {
            path: '/login',
            component: {
                // tslint:disable-next-line
                render(c) { return c('router-view'); },
            },
            children: [
                {
                    path: '/',
                    name: 'login',
                    // tslint:disable-next-line
                    component: Login,
                },
                {
                    path: 'authenticate',
                    name: 'authenticate',
                    component: Authenticate,
                    beforeEnter: steamAuthenticateReady,
                    // tslint:disable-next-line
                    props: (route: Route) => ({ code: route.query.code }),
                    pathToRegexpOptions: { strict: true },
                },
            ],
        },
        {
            path: '/user-guide/:categoryId?',
            name: 'userguide',
            component: UserGuide,
            props: true,
        },
        {
            path: '/terms',
            name: 'terms',
            component: Terms,
            props: {eula: false},
        },
        {
            path: '/eula',
            name: 'eula',
            component: Terms,
            props: {eula: true},
        },
    ],
});

router.beforeEach(languageGuard);
router.beforeEach(notFoundGuard);
router.beforeEach(configurationGuard);

router.afterEach(focusHook);

export default router;
